import { useProtecaoFormulario } from "@/shared/hooks/useProtecaoSaida";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useVoltarOu } from "@/modules/visitantes/hooks/useVoltarOu";
import { FormularioVisitante } from "@/modules/visitantes/components/FormularioVisitante";
import { PaginaFormulario, SemPermissao } from "@/modules/visitantes/components/PaginaFormulario";
import {
  useEditarVisitante,
  useFichaVisitante,
  usePapelVisitantes,
  useVisitantes,
} from "@/modules/visitantes/hooks/useVisitantes";
import type { DadosVisitante } from "@/modules/visitantes/services/visitantesService";
import { fichaParaDados } from "@/modules/visitantes/utils/conversao";
import { guardarAviso } from "@/modules/visitantes/utils/aviso";

/** Edição do cadastro — só o ministério responsável; usa a versão da ficha (concorrência otimista). */
export function EditarVisitantePage() {
  const { id } = useParams<{ id: string }>();
  const voltar = useVoltarOu(`/visitantes/${id}`);
  const protecao = useProtecaoFormulario();
  const { papel, carregando } = usePapelVisitantes();
  const {
    data: ficha,
    isLoading,
    isError,
  } = useFichaVisitante(papel === "gestao" ? id : undefined);
  const { data: existentes = [] } = useVisitantes(papel === "gestao");
  const editar = useEditarVisitante();
  const [erro, setErro] = useState<string | null>(null);

  if (carregando || (papel === "gestao" && isLoading))
    return <p className="px-4 py-10 text-center text-sm text-muted">Carregando…</p>;
  if (papel !== "gestao")
    return <SemPermissao texto="Só o ministério responsável edita visitantes." />;
  if (isError || !ficha || !id) return <SemPermissao texto="Visitante não encontrado." />;

  async function enviar(dados: DadosVisitante) {
    if (!ficha || !id) return;
    setErro(null);
    try {
      await editar.mutateAsync({ id, versao: ficha.versao, dados });
      guardarAviso("Cadastro atualizado.");
      protecao.liberar();
      voltar();
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Não foi possível salvar o cadastro.");
    }
  }

  return (
    <PaginaFormulario protecao={protecao} titulo="Editar visitante">
      <FormularioVisitante
        modo="edicao"
        inicial={fichaParaDados(ficha)}
        existentes={existentes}
        idAtual={id}
        semConsentimento={!!ficha.consentimento?.retirado_em && !ficha.consentimento?.em}
        enviando={editar.isPending}
        erro={erro}
        onEnviar={enviar}
        onCancelar={voltar}
      />
    </PaginaFormulario>
  );
}
